<template>
  <div class="button-combina">
    <div class="demo-spin-container" v-if="btnConfig.loading">
      <Spin fix></Spin>
    </div>
    <div class="button-content" :class="btnConfig.btnsite" v-if="btnConfig.buttons.length">
      <template v-for="(item, index) in btnConfig.buttons">
        <div
          class="button-group"
          v-if="item"
          :key="index"
          :class="item.hasOwnProperty('isShow') && item.isShow === false ? 'button-group-none' : ''"
        >
          <template
            v-if="item.hasOwnProperty('isShow') ? item.isShow : true"
          >
            <!-- icon 设置按钮的图标类型 custom-icon 设置按钮的自定义图标 -->
            <Button
              v-if="!item.dropDown"
              @click.native="cb(item)"
              :ref="item.ref"
              :type="item.type ? item.type : btnConfig.typeAll"
              :size="item.size ? item.size : 'small'"
              :custom-icon="item.customIcon ? item.customIcon : ''"
              :icon="item.icon ? item.icon : item.text == t('返回') ? 'md-return-left' : ''"
              :disabled="item.disabled ? item.disabled : false"
              :ghost="item.ghost ? true : false"
              :shape="item.shape ? item.shape : undefined"
              :class="[item.class, item.webname || '', !item.text && item.icon ? 'just-icon-btn' : '']"
              >{{ item.text }}</Button
            >
            <!-- 下拉菜单按钮 -->
            <Dropdown
              v-else-if="item.dropDown && item.menus.length > 0 && (item.isShow === undefined ? true : item.isShow)"
              @on-click="(a, b) => dropDownClick(a, b, item)"
            >
              <Button
                :ref="item.ref"
                :type="item.type ? item.type : btnConfig.typeAll"
                :size="item.size ? item.size : 'small'"
                :icon="item.icon ? item.icon : ''"
                :disabled="item.disabled ? item.disabled : false"
                :ghost="item.ghost ? false : true"
                :shape="item.shape ? item.shape : undefined"
                :class="item.class"
              >
                {{ item.menuText }}
                <Icon type="ios-arrow-down"></Icon>
              </Button>
              <DropdownMenu slot="list">
                <template v-for="(menu_item, index) in item.menus">
                <DropdownItem
                  :key="index"
                  v-if="menu_item.isShow === undefined ? true : menu_item.isShow"
                  :name="menu_item.webname"
                  :class="[menu_item.class, menu_item.webname || '']"
                >
                  <span v-if="!menu_item.dropDown">
                    <Icon v-if="menu_item.icon" :type="menu_item.icon" style="margin-right:2px;font-size:13px;"></Icon>
                    {{ menu_item.text }}
                  </span>
                  <!-- 三级按钮 -->
                  <Dropdown
                    placement="right-start"
                    v-else-if="menu_item.dropDown && menu_item.menus.length > 0"
                  >
                    <a
                      href="javascript:void(0)"
                      :ref="menu_item.ref"
                      :type="menu_item.type ? menu_item.type : btnConfig.typeAll"
                      :size="menu_item.size ? menu_item.size : 'small'"
                      :icon="menu_item.icon ? menu_item.icon : ''"
                      :disabled="menu_item.disabled ? menu_item.disabled : false"
                      :ghost="menu_item.ghost ? false : true"
                      :shape="menu_item.shape ? menu_item.shape : undefined"
                      :class="menu_item.class"
                    >
                      {{ menu_item.menuText }}
                      <Icon type="ios-arrow-forward"></Icon>
                    </a>
                    <DropdownMenu slot="list">
                      <DropdownItem
                        v-for="(three_item, index) in menu_item.menus"
                        :key="index"
                        :name="three_item.webname"
                        :class="[three_item.webname || '']"
                      >
                        {{ three_item.text }}
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <!-- end -->
                </DropdownItem>
                </template>
              </DropdownMenu>
            </Dropdown>
          </template>
        </div>
      </template>
      <template v-for="(item, index) in btnConfig.buttonsRight">
        <div
          class="button-group"
          v-f="item"
          :key="index"
        >
          <Button
            @click.native="cb(item)"
            v-if="item.hasOwnProperty('isShow') ? item.isShow : true"
            :ref="item.ref"
            :type="item.type ? item.type : btnConfig.typeAll"
            :size="item.size ? item.size : 'small'"
            :custom-icon="item.customIcon ? item.customIcon : ''"
            :icon="item.icon ? item.icon : ''"
            :disabled="item.disabled ? item.disabled : false"
            :ghost="item.ghost ? true : false"
            :shape="item.shape ? item.shape : undefined"
            :key="index"
            :class="[item.class, item.webname || '']"
            >{{ item.text }}</Button
          >
        </div>
      </template>
      <slot name="tail"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OmsButton',
  data() {
    return {};
  },

  props: {
    btnConfig: {
      type: Object
    },
    scopeRow: {
      type: Object
    }
  },

  methods: {
    cb(item) {
      if (item.hasOwnProperty('btnclick')) {
        this.scopeRow ? item.btnclick(this.scopeRow) : item.btnclick(item)
      } else {
        // 兼容后端调整按钮类型后的事件处理（eg: 下拉按钮 => 基础按钮）
        this.$listeners.dropDownClick && this.dropDownClick(item.webname, [], item)
      }
    },
    dropDownClick(name, events = [...eventlist], item) {
      this.$emit('dropDownClick', name, events, item)
    },
    button(ref) {
      this.$emit("buttonEvent", ref, this);
    }
  }
};
// import OmsButton from 'burgeonComponents/js/OmsButton.js';
// export default OmsButton;
</script>

<style lang="less" scoped>
@import "burgeonComponents/css/OmsButton.less";
</style>


